import { Block } from "@block";
import ScreenNameType from "@navigation/nav-screens";
import { RouteProp, StackActions, useNavigation, useRoute } from "@react-navigation/native";
import { spacing } from "@styles/spacing";
import { showModal } from "app/modules/modal-management/reducer/action";
import StackParamsList from "app/navigation/nav-stack-params";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { QueueSpacing } from "app/shared/components/spacing";
import { ITEMAUTOTOPUPBILLING } from "app/shared/services/services-model.type";
import { formatCurrency } from "app/shared/util/format-currency";
import React from "react";
import { useTranslation } from "react-i18next";
import { ScrollView, StyleSheet } from "react-native";
import { Button, useTheme } from "react-native-paper";
import { useDispatch, useSelector } from "react-redux";
import { fetchAutoTopUpDeleteRequest, fetchAutoTopUpListRequest, setAutoTopUpReset, setAutoTopUpStore } from "../reducer/actions";
import { getAutoTopUpListSelector, getAutoTopUpStoreSelector } from "../reducer/selectors";
import AutoTopUpRollTable, { DataAutoTopUpTableProps } from "./table/auto-top-up-roll-table";

type ProfileScreenRouteProp = RouteProp<StackParamsList, ScreenNameType.AUTO_TOP_UP_LIST>;

const AutoToUpRoll = () => {
  const { colors } = useTheme();
  const { t } = useTranslation();

  const { dispatch } = useNavigation();
  const dispatchStore = useDispatch();

  const goHome = () => {
    dispatch(StackActions.replace(ScreenNameType.HOME));
  };

  const goManager = () => {
    dispatch(StackActions.replace(ScreenNameType.LIST_PAYMENTS));
  };

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => goHome(),
    },
    {
      name: t("FUNC_THANH_TOAN"),
      onPressSubtitle: () => goManager(),
    },
    {
      name: t("AUTO_TOPUP_DANG_KY_NAP_TIEN_TU_DONG"),
      onPressSubtitle: () => {},
    },
  ];

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        buttonForm: { backgroundColor: colors.backgroundForm },
      }),
    [colors],
  );

  const routeProps = useRoute<ProfileScreenRouteProp>();

  const autoTopUpStore = useSelector(getAutoTopUpStoreSelector);
  const listAutoTopUpStore = useSelector(getAutoTopUpListSelector);

  const [dataList, setDataList] = React.useState<DataAutoTopUpTableProps[]>([]);

  const requestDelete = (item: ITEMAUTOTOPUPBILLING) => {
    dispatchStore(fetchAutoTopUpDeleteRequest(item));
  };

  const onPressAddNew = () => {
    dispatch(StackActions.replace(ScreenNameType.AUTO_TOP_UP_CREATE, { resetData: true }));
  };

  const onPressHistory = (_item: ITEMAUTOTOPUPBILLING) => {
    console.log("onPressHistory: ", _item);
    dispatch(StackActions.replace(ScreenNameType.AUTO_TOP_UP_HISTORY, { item: _item }));
  };
  const onPressDelete = (_item: ITEMAUTOTOPUPBILLING) => {
    console.log("onPressDelete: ", _item);
    dispatchStore(
      showModal({
        modalType: "multiAction",
        modalProps: {
          open: true,
          message: t("AUTO_TOPUP_QUY_KHACH_MUON_HUY_GIAO_DICH"),
          titleBtnCancel: t("COMMON_HUY"),
          acceptModal: () => requestDelete(_item),
        },
      }),
    );
  };

  const getDataTable = React.useCallback(
    (_data?: ITEMAUTOTOPUPBILLING[]): Array<DataAutoTopUpTableProps> => {
      if (_data?.length) {
        _data.map((obj: DataAutoTopUpTableProps, index: number) => {
          obj.id = String(index + 1);
          obj.SERVICE_NAME = t("TOPUP_NAP_TIEN_DIEN_THOAI");
          obj.PAY_DATE =
            obj?.paydate && obj?.paynow === "N"
              ? t("AUTO_TOPUP_NGAY_NAP_HANG_THANG").replace(
                  "{ngay}",
                  // eslint-disable-next-line radix
                  parseInt(obj?.paydate) < 10 ? "0" + obj?.paydate : obj?.paydate,
                )
              : t("AUTO_TOPUP_LAN_KHUYEN_MAI_DAU_TIEN");
          obj.DENOMINATIONS_CURRENCY = formatCurrency(obj.denominations || "");
          return obj;
        });
        return _data;
      }
      return [];
    },
    [t],
  );

  React.useEffect(() => {
    const dataMap: DataAutoTopUpTableProps[] = getDataTable(listAutoTopUpStore);
    setDataList(dataMap);
  }, [getDataTable, listAutoTopUpStore]);

  React.useEffect(() => {
    if (routeProps?.params?.resetData === true) {
      dispatchStore(setAutoTopUpReset());
      dispatchStore(fetchAutoTopUpListRequest());
    }
  }, [dispatchStore, routeProps?.params?.resetData]);

  React.useEffect(() => {
    if (autoTopUpStore.statusDelete === "ok" && autoTopUpStore.resDelete?.billno?.length) {
      let _data: ITEMAUTOTOPUPBILLING[] | undefined = autoTopUpStore.resListAutoTopUp || [];
      if (_data.length) {
        _data = autoTopUpStore.resListAutoTopUp?.filter((_item) => {
          return _item.billno !== autoTopUpStore.resDelete?.billno;
        });
        console.log("delete filter: ", _data);
      }
      dispatchStore(
        setAutoTopUpStore({
          ...autoTopUpStore,
          resDelete: undefined,
          statusDelete: "init",
          resListAutoTopUp: _data,
        }),
      );
    }
  }, [dispatchStore, autoTopUpStore]);

  const ButtonRow = (
    <Block row middle pv={spacing.huge}>
      <Button onPress={goHome} mode="contained" style={styles.buttonForm}>
        {t("FUNC_TRANG_CHU")}
      </Button>
      <QueueSpacing size="large" />
      <Button onPress={onPressAddNew} mode="contained">
        {t("AUTO_TOPUP_DANG_KY_THEM")}
      </Button>
    </Block>
  );

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("AUTO_TOPUP_DANH_SACH_DANG_KY_NAP_TIEN_TU_DONG")} subtitles={subtitlesArrays} />
        <AutoTopUpRollTable data={dataList} onPressHistory={onPressHistory} onPressDelete={onPressDelete} onChangeData={() => {}} />
        {ButtonRow}
      </ScrollView>
    </Block>
  );
};

export default AutoToUpRoll;
